import ModuleInfo from "./ModuleInfo";
export default ModuleInfo